import React from 'react';
import DashboardContainer from '../../../Containers/AdminContainer/Dashboard';
import AdminLayout from '../../../Components/CommonComponents/Layout/adminLayout';
const Dashboard = (props) => {
  return <DashboardContainer />;
};

export default Dashboard;
